<template>
    <div class="px-section mt-16 md:mt-40 flex flex-col-reverse md:grid md:grid-cols-10">
        <div class="col-start-1 col-span-4 space-y-0 md:space-y-8 portfolio md:pr-10">
            <section class="section-portfolio">
                <h1 class="title-section-bold">Portfólio</h1>
                <p class="text-xl-size">Nossos projetos são o nosso orgulho!</p>
                <p class="text-xl-size">Em 21 anos de atuação, já desenvolvemos e implementamos soluções que impactaram grandes e pequenas empresas através da inovação e da transformação digital.</p>
            </section>
            <div @click="toggle">
                <div class="flex justify-between items-center">
                    <h4>Energia e Utilities</h4>
                    <div class="arrow-down"></div>
                </div>
                <div class="projects-list">
                    <a
                        v-for="project in projects[0]" :key="project.value"
                        :class="`${project.value === projectShowing.value? 'project-showing': 'light-text-gray-list'}`"
                        href="#portfolio-main-content"
                        @click="selectedProject(project)"
                    >
                        {{project.text}}
                    </a>
                </div>
            </div>
            <div @click="toggle">
                <div class="flex justify-between items-center">
                    <h4>Transformação Digital</h4>
                    <div class="arrow-down"></div>
                </div>
                <div class="projects-list">
                    <a
                        v-for="project in projects[1]" :key="project.value"
                        :class="`${project.value === projectShowing.value? 'project-showing': 'light-text-gray-list'}`"
                        href="#portfolio-main-content"
                        @click="selectedProject(project)"
                    >
                        {{project.text}}
                    </a>
                </div>
            </div>
            <!-- <div @click="toggle">
                <div class="flex justify-between items-center">
                <h4>Educação à Distância</h4>
                  <div class="arrow-down"></div>
                </div>
                <div class="projects-list">
                    <a
                      class="text-medium-size"
                      :class="`${projects[2][0].value === projectShowing.value? 'project-showing': 'light-text-gray-list'}`"
                      href="#portfolio-portfolio-main-content"
                      @click="selectedProject(projects[2][0])"
                    >
                        {{projects[2][0].text}}
                    </a>
                </div>
            </div> -->
        </div>
        <div class="col-start-5 py-5 col-span-6 h-full bg-gray-50 bg-portolio-content">
            <ShowingContent  :project-showing="projectShowing" />
        </div>
        <div id="portfolio-main-content" class="md:hidden pl-5 -mb-4">
            <h1 class="title-section-bold">Portfólio</h1>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import ShowingContent from '@/Components/Home/Portfolio/ShowingContent.vue';

const selectedProject = (project) => {
    projectShowing.value = project;
};

const toggle = (event) => {
    // @ts-ignore
    if (getComputedStyle(document.getElementById('portfolio-main-content')).display === 'none') {
        event.preventDefault();
    }

    if (event.target.parentElement.classList.contains('nav-project')) {
        event.target.parentElement.classList.remove('nav-project');
    } else event.target.parentElement.classList.add('nav-project');
}

const projects = ref([
    [
        {
            text: 'Gestão de Projetos',
            value: 0,
            name: 'sgp4'
        },
        {
            text: 'Chamadas Públicas',
            value: 1,
            name: 'chamada_publica'
        },
        {
            text: 'Calculadora de Carbono',
            value: 2,
            name: 'calculadora_de_carbono'
        },
        {
            text: 'Simulador de Consumo',
            value: 3,
            name: 'simulador_de_consumo'
        },
    ],
    [
        {
            text: 'Gestão de Reuniões',
            value: 4,
            name: 'gestao_de_reunioes'
        },
        // {
        //     text:'Sistema de Horas-extras',
        //     value:5,
        //     name:'sistema_de_horas_extras'
        // },
    ],
    [
        {
            text: 'Plataforma de Ensino',
            value: 6,
            name: 'plataforma_de_ensino'
        },
    ],
]);

const projectShowing = ref(projects.value[0][0]);
/*
import ShowingContent from "./ShowingContent.vue"

export default {
    components:{
        ShowingContent
    },

    data(){
        return {
            projects:[
                [
                    {
                        text:'Gestão de Projetos',
                        value:0,
                        name:'sgp4'
                    },
                    {
                        text:'Chamadas Públicas',
                        value:1,
                        name:'chamada_publica'
                    },
                    {
                        text:'Calculadora de Carbono',
                        value:2,
                        name:'calculadora_de_carbono'
                    },
                    {
                        text:'Simulador de Consumo',
                        value:3,
                        name:'simulador_de_consumo'
                    },
                ],
                [
                    {
                        text:'Gestão de Reuniões',
                        value:4,
                        name:'gestao_de_reunioes'
                    },
                    // {
                    //     text:'Sistema de Horas-extras',
                    //     value:5,
                    //     name:'sistema_de_horas_extras'
                    // },
                ],
                [
                    {
                        text:'Plataforma de Ensino',
                        value:6,
                        name:'plataforma_de_ensino'
                    },
                ],
            ],
            projectShowing:{},
        }
    },
    created(){
        this.projectShowing = this.projects[0][0];

    },
    methods:{
        selectedProject(project){
            this.projectShowing = project;
        },
        toggle(event) {
                if(event.target.parentElement.classList.contains('nav-project')){
                    event.target.parentElement.classList.remove('nav-project');
                } else event.target.parentElement.classList.add('nav-project');
        }
    }
}
*/
</script>

<style lang="postcss" scoped>
.nav-project {
    @media (max-width: 767px) {
        & .projects-list{
            display: flex !important;
        }
    }
}

h4,.arrow-down{
    pointer-events: none;
    user-select: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
}

.project-showing {
    color: #2e9fea;
}

.light-text-gray-list{
 color: #AFB6BF;
}

.bg-portfolio-projects {
    @media (max-width: 767px) {
        background-color: #2e9fea;
    }
}

.bg-portolio-content {
    background-color: #E2F1FA;
}

.projects-list {
    @apply py-3 md:py-0 space-y-3 md:space-y-5 flex flex-col;

}

.portfolio {
    & > * {
        @apply mb-3;
    }

    & > * > :first-child {
        @apply mb-3 md:mb-5 font-semibold;
    }
    & > :last-child{
        @apply mb-4;
    }

    & > :not(:first-child) > :first-child{
        font-size: 1.3rem;
        border-bottom: solid 1px white;
        @apply md:text-2xl mb-0 md:mb-2 text-white md:text-current bg-portfolio-projects md:bg-transparent px-5 py-2;
    }


    & > :not(:first-child) > :not(:first-child) {
        & > * {
            font-size: 1.3rem;
            @apply md:text-2xl pl-6 md:pl-0;

            &:hover {
                cursor: pointer;
                color: #2e9fea;
            }
        }
    }

    & .projects-list {
        @apply pl-2 md:pl-5;

        @media (max-width: 768px) {
            @apply hidden;
        }
    }
}

.section-portfolio {
    max-width: 500px;
    @apply mt-2 hidden md:block;
}
</style>
